import * as d3 from "d3";

export const TiltGauge = ({ tilt, label }) => {
  const width = 375;
  const height = 180;

  // Map tilt degrees (-60 → 60) to radians
  const angleScale = d3
    .scaleLinear()
    .domain([-60, 60])
    .range([-Math.PI / 3, Math.PI / 3]);

  // Half-donut arc
  const arc = d3
    .arc()
    .innerRadius(100)
    .outerRadius(160)
    .startAngle(-Math.PI / 2)
    .endAngle(Math.PI / 2);

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="xMidYMid meet"
      style={{ width: "100%", height: "auto", display: "block" }}
    >
      {/* Gradient definition */}
      <defs>
        <linearGradient id="tiltGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#27ae60" />
          <stop offset="25%" stopColor="#f1c40f" />
          <stop offset="50%" stopColor="#c0392b" />
          <stop offset="75%" stopColor="#f1c40f" />
          <stop offset="100%" stopColor="#27ae60" />
        </linearGradient>
      </defs>

      <g transform={`translate(${width / 2}, ${height - 10})`}>
        {/* Half-donut */}
        <path d={arc()} fill="url(#tiltGradient)" opacity={.25}/>

        {/* Tilt bar */}
        <line
          x1={-110}
          y1={-50}
          x2={110}
          y2={-50}
          stroke={tilt > -4 && tilt < 4  ? "#27ae60" : "#c0392b"}
          strokeWidth={10}
          strokeLinecap="round"
          transform={`rotate(${(angleScale(tilt) * 180) / Math.PI})`}
        />

        {/* Label */}
        <text
          y={-10}
          textAnchor="middle"
          fill="#000"
          fontSize={14}
          fontWeight="bold"
        >
          {label} ({tilt.toFixed(1)}°)
        </text>
      </g>
    </svg>
  );
};
